import axios from 'axios';
import config from '../../src/client/config';

const {
  apiRoot,
  serviceApiRoot,
  b2bApiRoot,
  blogApiRoot,
  filemakerApiRoot,
} = config;

const endPoints = {
  List: { root: serviceApiRoot, path: '/v1/search/list' },
  ListFilters: { root: serviceApiRoot, path: '/v1/search/list/filters' },
  Profile: { root: serviceApiRoot, path: '/v1/search/profile' },
  FindNearestSuburb: { root: serviceApiRoot, path: '/v1/search/suburbs' },
  Blogs: { root: serviceApiRoot, path: '/v1/search/blogs' },
  Suggest: { root: serviceApiRoot, path: '/v1/search/suggest' },
  Suburbs: {
    root: serviceApiRoot,
    path: '/v1/search/suggest/suburbs',
  },
  CategorySitemap: {
    root: serviceApiRoot,
    path: '/v1/search/suggest/sitemap/categories',
  },
  QuotableCategorySuggest: {
    root: serviceApiRoot,
    path: '/v1/search/suggest/quotable/categories',
  },
  SuburbSitemap: {
    root: serviceApiRoot,
    path: '/v1/search/suggest/sitemap/suburbs',
  },
  ABNSearch: {
    root: serviceApiRoot,
    path: '/v1/search/suggest/business/accounts',
  },
  Sitemap: { root: serviceApiRoot, path: '/v1/search/seo/sitemap' },
  SeoHome: { root: serviceApiRoot, path: '/v1/search/seo/home' },
  SeoList: { root: serviceApiRoot, path: '/v1/search/seo/list' },
  SeoState: { root: serviceApiRoot, path: '/v1/search/seo/state' },
  SeoSuburb: { root: serviceApiRoot, path: '/v1/search/seo/suburb' },
  SeoRegion: { root: serviceApiRoot, path: '/v1/search/seo/region' },
  SeoSuburbListings: {
    root: serviceApiRoot,
    path: '/v1/search/seo/suburbListings',
  },
  SeoPopularSuburbs: {
    root: serviceApiRoot,
    path: '/v1/search/seo/popularSuburbs',
  },
  SeoCategory: {
    root: serviceApiRoot,
    path: '/v1/search/seo/category',
  },
  SearchProfileReviews: {
    root: serviceApiRoot,
    path: '/v1/search/profile/reviews',
  },
  Category: { root: serviceApiRoot, path: '/v1/search/category' },
  ListingRequest: { root: serviceApiRoot, path: '/v1/listings' },
  ListingsCount: { root: serviceApiRoot, path: '/v1/search/listings/count' },
  ReviewAggregates: { root: serviceApiRoot, path: '/v1/reviewAggregates' },
  Reviews: { root: serviceApiRoot, path: '/v1/reviews' },
  Enquiries: { root: serviceApiRoot, path: '/v1/enquiries' },
  Assets: { root: serviceApiRoot, path: '/v1/assets' },
  Quotes: { root: serviceApiRoot, path: '/v1/quotes' },
  ReCaptcha: { root: apiRoot, path: '/v1/recapture' },
  DaapiReviews: { root: apiRoot, path: '/v1/reviews' },
  PIDForm: { root: apiRoot, path: '/v1/pid_form' },
  PIDAuth: { root: apiRoot, path: '/v1/pid_auth' },
  DaapiInvitations: { root: apiRoot, path: '/v1/invitations' },
  ReviewResponse: { root: apiRoot, path: '/v1/review_responses' },
  Reports: { root: apiRoot, path: '/v1/reports' },
  Moderation: { root: apiRoot, path: '/v1/moderation' },
  DaapiQuoteApproval: { root: apiRoot, path: '/v1/quote_approval' },
  QuoteApproval: { root: serviceApiRoot, path: '/v1/quoteApproval' },
  B2BLocations: {
    root: b2bApiRoot,
    path: '/wp-json/localsearch/v1/locations',
  },
  BusinessBlog: { root: b2bApiRoot, path: '/wp-json/localsearch/v1/posts' },
  LifestyleBlog: { root: blogApiRoot, path: '/wp-json/localsearch/v1/posts' },
  FMQuoteApproval: { root: filemakerApiRoot, path: '/v1/fmQuoteApproval' },
  FMProofApproval: { root: filemakerApiRoot, path: '/v1/fmProofApproval' },
  FMDigitalContractApproval: {
    root: filemakerApiRoot,
    path: '/v1/fmDigitalContractApproval',
  },
  GetIPAddress: { root: 'https://api.ipify.org?format=json', path: '' },
  PidImageNotification: {
    root: serviceApiRoot,
    path: '/v1/pidImageNotification',
  },
};

const restApi = async (
  api,
  { method = 'get', path, ...params } = {},
  setData = () => {},
  setLoading = () => {},
  setError = () => {},
  setSuccess = () => {}
) => {
  setLoading(true);
  try {
    const response = await axios({
      method,
      url: `${endPoints[api].root}${endPoints[api].path}${
        path ? `/${path}` : ''
      }`,
      timeout: method === 'get' ? 10000 : 30000,
      ...params,
    });
    let { data } = response;
    const { status, headers } = response;
    if (Array.isArray(data)) {
      data = {
        data,
      };
    }
    const dataWithType = {
      type: api,
      status,
      headers,
      ...data,
    };
    setError(false);
    setSuccess(true);
    setData(dataWithType);
    return dataWithType;
  } catch (e) {
    setError(e);
    setLoading(false);
    // console.error(e);
    throw e;
  } finally {
    setLoading(false);
  }
};

export default restApi;
